import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { getZipEntries } from "requesters/uploadsRequester"
import { getBaseUrl } from "../../../reducers"

const ZipContentsPreview = ({ fileId }) => {
  const baseUrl = useSelector(getBaseUrl)
  const [entries, setEntries] = useState([])
  const [status, setStatus] = useState("loading")
  const [viewing, setViewing] = useState(null)
  const [viewError, setViewError] = useState(null)

  const viewEntry = async name => {
    setViewing(name)
    setViewError(null)
    try {
      const entryUrl = `${baseUrl}/uploads/${fileId}/zip-entry?entry=${encodeURIComponent(name)}`
      const response = await fetch(entryUrl, {
        headers: { Authorization: gon.auth_token }
      })
      if (!response.ok) {
        setViewError(name)
        return
      }

      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      window.open(url, "_blank")
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    } catch (_err) {
      setViewError(name)
    } finally {
      setViewing(null)
    }
  }

  useEffect(() => {
    let mounted = true
    if (!baseUrl || !fileId) return undefined

    getZipEntries(baseUrl, fileId)
      .then(result => {
        if (!mounted) return
        const names = result?.response?.json?.entries || result?.response?.entries
        if (result.status === 200 && Array.isArray(names)) {
          setEntries(names)
          setStatus("ready")
        } else {
          setStatus("error")
        }
      })
      .catch(() => {
        if (mounted) setStatus("error")
      })

    return () => {
      mounted = false
    }
  }, [baseUrl, fileId])

  if (status === "loading") {
    return <div className="text-muted small ml-4 mt-1">Loading preview...</div>
  }

  if (status === "error") {
    return <div className="text-muted small ml-4 mt-1">Preview unavailable</div>
  }

  if (!entries.length) {
    return <div className="text-muted small ml-4 mt-1">Zip is empty</div>
  }

  return (
    <ul className="text-muted small mb-0 mt-1 ml-4 pl-3">
      {entries.map((name, index) => (
        <li key={`${name}-${index}`}>
          <span>{name}</span>
          <button
            type="button"
            className="btn btn-link btn-sm p-0 ml-2 align-baseline"
            disabled={viewing === name}
            onClick={() => viewEntry(name)}>
            {viewing === name ? "Opening..." : "View"}
          </button>
          {viewError === name && <span className="ml-2">Could not open file</span>}
        </li>
      ))}
    </ul>
  )
}

ZipContentsPreview.propTypes = {
  fileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ZipContentsPreview
